import { createMigrate } from 'redux-persist';
import storage from 'redux-persist/es/storage';

const buildPersistConfig = (key, { blacklist, whitelist, migrations = {}, transforms = [], version = 1 }) => {
  return {
    key,
    version,
    storage,
    blacklist,
    whitelist,
    transforms,
    migrate: createMigrate(migrations, { debug: false })
  };
};

export default buildPersistConfig;
